






import { computed, defineComponent } from '@vue/composition-api';

import PurchaseDashboard from '@/components/Dashboard/PurchaseDashboard.vue';
import StoreDashboard from '@/components/Dashboard/StoreDashboard.vue';
import ProductionDashboard from '@/components/Dashboard/ProductionDashboard.vue';

const Index = defineComponent({
  components: {
    PurchaseDashboard,
    StoreDashboard,
    ProductionDashboard,
  },
  setup(props, { root }) {
    const dashboard = computed(() => root.$store.getters.dashboard || []);

    const dashboardRenderCondition = computed(() => {
      if (dashboard.value.indexOf('purchase') > -1) return PurchaseDashboard;
      if (dashboard.value.indexOf('prod') > -1) return ProductionDashboard;
      if (dashboard.value.indexOf('store') > -1) return StoreDashboard;
      return null;
    });

    return {
      dashboard,
      dashboardRenderCondition,
    };
  },
});

export default Index;
